import { Provider } from '@angular/core';
import { provideEffects } from '@ngrx/effects';
import { provideState } from '@ngrx/store';
import { CheckoutEffects } from '../+state/checkout.effects';
import * as fromCheckout from '../+state/checkout.reducer';

export function provideCheckoutStore(): Provider {
  return [
    provideState(
      fromCheckout.CHECKOUT_FEATURE_KEY,
      fromCheckout.checkoutReducer
    ),
    provideEffects(CheckoutEffects),
  ];
}
